const CLIENT_RUN_KEY = 'argus_clientRunId';

function makeClientRunId(): string {
  const random =
    typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
  return `argus-${random}`;
}

export function readClientRunId(): string | null {
  try {
    const value = localStorage.getItem(CLIENT_RUN_KEY)?.trim();
    return value || null;
  } catch {
    return null;
  }
}

export function getOrCreateClientRunId(): string {
  const existing = readClientRunId();
  if (existing) return existing;
  const next = makeClientRunId();
  try {
    localStorage.setItem(CLIENT_RUN_KEY, next);
  } catch {
    // The backend still works without idempotency if browser storage is unavailable.
  }
  return next;
}

export function resetClientRunId(): string {
  const next = makeClientRunId();
  try {
    localStorage.setItem(CLIENT_RUN_KEY, next);
  } catch {
    // ignore storage failures
  }
  return next;
}

export function clearClientRunId(): void {
  try {
    localStorage.removeItem(CLIENT_RUN_KEY);
  } catch {
    // ignore storage failures
  }
}
